import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResourceCenterComponent } from './resource-center-side-bar.component';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { ResourceCenterContentModule } from '../resource-center-content/resource-center-content.module';

@NgModule({
  declarations: [ResourceCenterComponent],
  imports: [CommonModule, I18nModule, ResourceCenterContentModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ResourceCenter: {
          component: ResourceCenterComponent,
        },
      },
    }),
  ],
})
export class ResourceCenterModule {}
